import React from "react";
import "./MainAnalytics.scss";

import { FaAngleRight } from "react-icons/fa6";
import { Link, useOutletContext } from "react-router-dom";
import { useSelector } from "react-redux";
import ROUTES from "../../../constants/routes";
import { useViewPortDetector } from "../../../helpers/viewPortDetector";

const MainAnalytics = () => {
  const { currency } = useSelector((state) => state.organizationReducer.value);

  const {
    revenueAnalytics,
    productsAnalytics,
    categoriesAnalytics,
    paymentMethodsAnalytics,
    branchAnalytics,
    staffAnalytics,
    customerAnalytics,
  } = useSelector((state) => state.analyticsReducer);

  const { setSelectedDesktopTab, selectedDesktopTab } = useOutletContext();
  const { currentViewPort } = useViewPortDetector();
  return (
    <div className="analytics-list container-wrapper">
      <Link
        to={currentViewPort === "desktop" ? "#" : ROUTES.revenueAnalytics.path}
        onClick={() => {
          setSelectedDesktopTab && setSelectedDesktopTab("Revenue");
        }}
        className={`item ${
          selectedDesktopTab === "Revenue" ? "active" : ""
        }`}
      >
        <div className="left">
          <p>Revenue</p>
          <span>
            Best day: {revenueAnalytics?.best_day_for_revenue || "N/A"}
          </span>
        </div>
        <div className="right">
          <p className="success">
            {currency}{revenueAnalytics?.total_revenue || "0.00"}
          </p>
          <div className="end">
            <img src="/images/analytics/sale.svg" alt="" aria-label="Revenue Analytics" />
            <FaAngleRight />
          </div>
        </div>
      </Link>

      <Link
        to={currentViewPort === "desktop" ? "#" : ROUTES.salesAnalytics.path}
        onClick={() => {
          setSelectedDesktopTab && setSelectedDesktopTab("Sales");
        }}
        className={`item ${
          selectedDesktopTab === "Sales" ? "active" : ""
        }`}
      >
        <div className="left">
          <p>Sales</p>
          <span>Best Day: {revenueAnalytics?.best_day_for_sales || "N/A"}</span>
        </div>
        <div className="right">
          <p className="primary">{revenueAnalytics?.total_sales || "0.00"}</p>
          <div className="end">
            <img src="/images/analytics/sale.svg" alt="" aria-label="Sales Analytics" />
            <FaAngleRight />
          </div>
        </div>
      </Link>

      <Link
        to={currentViewPort === "desktop" ? "#" : ROUTES.productAnalytics.path}
        onClick={() => {
          setSelectedDesktopTab && setSelectedDesktopTab("Products");
        }}
        className={`item ${
          selectedDesktopTab === "Products" ? "active" : ""
        }`}
      >
        <div className="left">
          <p>Top Products</p>
          <span>
            #1 in Sales: {currency}
            {Number(productsAnalytics?.best_product?.amount || 0).toFixed(2) || "0.00"}
          </span>
        </div>
        <div className="right">
          <p className="dark-bg">
            {productsAnalytics?.best_product?.name || "N/A"}
          </p>
          <div className="end">
            <img src="/images/analytics/revenue.svg" alt="" aria-label="Products Analytics" />
            <FaAngleRight />
          </div>
        </div>
      </Link>

      <Link
        to={currentViewPort === "desktop" ? "#" : ROUTES.categoryAnalytics.path}
        onClick={() => {
          setSelectedDesktopTab && setSelectedDesktopTab("Categories");
        }}
        className={`item ${
          selectedDesktopTab === "Categories" ? "active" : ""
        }`}
      >
        <div className="left">
          <p>Top Category</p>
          <span>
            #1 in Sales: {currency}
            {Number(categoriesAnalytics?.best_category?.total_amount || 0).toFixed(2) || "0.00"}
          </span>
        </div>
        <div className="right">
          <p className="dark-bg">
            {categoriesAnalytics?.best_category?.name || "N/A"}
          </p>
          <div className="end">
            <img src="/images/analytics/revenue.svg" alt="" aria-label="Categories Analytics" />
            <FaAngleRight />
          </div>
        </div>
      </Link>

      {/* <Link to={ROUTES.profitsAnalytics.path} className="item">
        <div className="left">
          <p>Profits</p>
          <span>Best day: Aug 04</span>
        </div>
        <div className="right">
          <p className="danger">-{currency}5000</p>
          <div className="end">
            <img src="/images/analytics/profits.svg" alt="" aria-label="Profits Analytics" />
            <FaAngleRight />
          </div>
        </div>
      </Link> */}

      <Link
        to={currentViewPort === "desktop" ? "#" : ROUTES.paymentAnalytics.path}
        onClick={() => {
          setSelectedDesktopTab &&
            setSelectedDesktopTab("Payment Methods");
        }}
        className={`item ${
          selectedDesktopTab === "Payment Methods" ? "active" : ""
        }`}
      >
        <div className="left">
          <p>Payment Methods</p>
          <span>
            Paid by{" "}
            {paymentMethodsAnalytics?.best_payment_method?.label || "N/A"}
          </span>
        </div>
        <div className="right">
          <p className="primary">
            {Number(
              paymentMethodsAnalytics?.best_payment_method?.percentage || 0
            ).toFixed(2)}
            %
          </p>
          <div className="end">
            <img src="/images/analytics/payment.svg" alt="" aria-label="Payment Method Analytics" />
            <FaAngleRight />
          </div>
        </div>
      </Link>

      <Link
        onClick={() => {
          setSelectedDesktopTab && setSelectedDesktopTab("Branches");
        }}
        to={currentViewPort === "desktop" ? "#" : ROUTES.branchAnalytics.path}
        className={`item ${
          selectedDesktopTab === "Branches" ? "active" : ""
        }`}
      >
        <div className="left">
          <p>Top Branches</p>
          <span>Top branch: {branchAnalytics?.best_branch?.name || "N/A"}</span>
        </div>
        <div className="right">
          <p className="success">
            {currency}{branchAnalytics?.best_branch?.revenue || "0.00"}
          </p>
          <div className="end">
            <img src="/images/analytics/sale-tax.svg" alt="" aria-label="Branches Revenue and Sales Analytics" />
            <FaAngleRight />
          </div>
        </div>
      </Link>

      <Link
        to={
          currentViewPort === "desktop"
            ? "#"
            : ROUTES.salesByStaffAnalytics.path
        }
        onClick={() => {
          setSelectedDesktopTab && setSelectedDesktopTab("Staffs");
        }}
        className={`item no-image ${
          selectedDesktopTab === "Staffs" ? "active" : ""
        }`}
      >
        <div className="left">
          <p>Sales By Staff</p>
          <span>
            #1 in Purchases: {currency}
            {staffAnalytics?.best_seller?.total_revenue || "0.00"}
          </span>
        </div>
        <div className="right">
          <div className="end">
            <p>{staffAnalytics?.best_seller?.name || "N/A"}</p>
            <FaAngleRight />
          </div>
        </div>
      </Link>

      <Link
        to={
          currentViewPort === "desktop"
            ? "#"
            : ROUTES.salesByCustomerAnalytics.path
        }
        onClick={() => {
          setSelectedDesktopTab && setSelectedDesktopTab("Customers");
        }}
        className={`item no-image ${
          selectedDesktopTab === "Customers" ? "active" : ""
        }`}
      >
        <div className="left">
          <p>Top Customers</p>
          <span>
            #1 in Purchases: {currency}
            {customerAnalytics?.best_customer?.total_revenue || "0.00"}
          </span>
        </div>
        <div className="right">
          <div className="end">
            <p>{customerAnalytics?.best_customer?.name || "N/A"}</p>
            <FaAngleRight />
          </div>
        </div>
      </Link>
    </div>
  );
};

export default MainAnalytics;
